import { ComponentRef, SimpleChanges } from "@angular/core";
import { Subscription } from "rxjs";

export class DynamicComponentRef<T> extends ComponentRef<T> {
    get changeDetectorRef() {
        return this.baseComponentRef.changeDetectorRef;
    }
    get componentType() {
        return this.baseComponentRef.componentType;
    }
    get location() {
        return this.baseComponentRef.location;
    }
    get injector() {
        return this.baseComponentRef.injector;
    }
    get instance() {
        return this.baseComponentRef.instance;
    }
    get hostView() {
        return this.baseComponentRef.hostView;
    }

    private hasChanged = new Set<string>();
    private outputSubscriptions: Array<Subscription> = [];
    private isFirstChange() {
        return this["firstChange"];
    }

    constructor(private baseComponentRef: ComponentRef<T>) {
        super();
    }

    destroy() {
        for (const subscription of this.outputSubscriptions) {
            subscription.unsubscribe();
        }
        this.baseComponentRef.destroy();
        const element = this.baseComponentRef.location.nativeElement;
        element.parentNode.removeChild(element);
    }

    onDestroy(callback: Function) {
        this.baseComponentRef.onDestroy(callback);
    }

    updateInputs(newValues: any) {
        const changes: SimpleChanges = {};
        for (const key of Object.keys(newValues)) {
            changes[key] = {
                previousValue: this.instance[key],
                currentValue: newValues[key],
                firstChange: !this.hasChanged.has(key),
                isFirstChange: this.isFirstChange,
            };
            this.instance[key] = newValues[key];
            this.hasChanged.add(key);
        }
        if (this.instance["ngOnChanges"]) {
            this.instance["ngOnChanges"](changes);
        }
    }

    subscribeToOutput(key: string, handler: Function) {
        this.outputSubscriptions.push(this.baseComponentRef.instance[key].subscribe(handler));
    }
}
